"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDDPreviewCard = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const styled_components_1 = __importDefault(require("styled-components"));
const dompurify_1 = require("dompurify");
/* Polaris will always overwrite styles because this preview will be shown within some
form of Polaris component, such as 'Page' even. We need to define the basic styling for
common elements again here so they display correctly when rendering the preview.
*/
const HTMLContent = styled_components_1.default.div `
  * {
    all: revert;
  }

  /* re-apply some typography defaults so wrapped text doesn't look so weird */
  line-height: 1.4;
  word-break: break-word;
`;
const EDDPreviewCard = ({ html }) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(polaris_1.BlockStack, { gap: '400', id: 'edd-preview-card' },
                react_1.default.createElement(polaris_1.Text, { as: 'h3', id: 'edd-product-page-preview-title', variant: 'headingSm' }, "Product Page Preview"),
                react_1.default.createElement(polaris_1.Box, { background: 'bg-surface-secondary', padding: '400' },
                    react_1.default.createElement(polaris_1.SkeletonBodyText, null)),
                react_1.default.createElement(polaris_1.Box, { background: 'bg-fill-inverse', color: 'text-inverse', padding: '300' },
                    react_1.default.createElement(polaris_1.Text, { alignment: 'center', as: 'p', fontWeight: 'semibold', variant: 'bodySm' }, "ADD TO CART")),
                react_1.default.createElement(HTMLContent, null, renderHTML(html))))));
    /* eslint-disable react/no-danger */
    function renderHTML(previewHTML) {
        const safeHTML = (0, dompurify_1.sanitize)(previewHTML);
        return (react_1.default.createElement("div", { className: 'delivery-date-preview-display', dangerouslySetInnerHTML: { __html: safeHTML } }));
    }
};
exports.EDDPreviewCard = EDDPreviewCard;
